'use strict';
function btyRecentlyProduct(doc = document) {
  if (!doc || !window.btyGlobals || !btyGlobals.last_product_id) return;
  const selectors = doc.querySelectorAll('.product-recently-viewed');
  if (!selectors.length) return;
  const current = String(btyGlobals.last_product_id);
  let ids = [];
  try {
    const stored = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
    if (Array.isArray(stored)) ids = stored.map(String).filter(id => /^\d+$/.test(id));
    ids = [current, ...ids.filter(id => id !== current)].slice(0, 20);
    localStorage.setItem('recently-viewed', JSON.stringify(ids));
  } catch (error) { return; }
  ids = ids.filter(id => id !== String(btyGlobals.is_product));
  if (!ids.length) return;
  selectors.forEach(async el => {
    const dataUrl = el.getAttribute('data-url');
    const section = el.closest('.shopify-section');
    if (!dataUrl || !section || el.dataset.loading === 'true') return;
    el.dataset.loading = 'true';
    try {
      const url = new URL(dataUrl, window.location.origin);
      url.searchParams.set('q', ids.map(id => 'id:' + id).join(' OR '));
      const response = await fetch(url.href);
      if (!response.ok) throw new Error('No se pudo cargar el historial.');
      const dom = new DOMParser().parseFromString(await response.text(), 'text/html');
      const viewed = dom.querySelector('.product-recently-viewed');
      if (!viewed || !viewed.innerHTML.trim()) { section.classList.remove('has-products-recently'); return; }
      el.innerHTML = viewed.innerHTML;
      section.classList.add('has-products-recently');
      btyAddToCart(el);
      btyCarousel(el);
      btyAddWishlist(el);
      btyQuickView(el);
      el.removeAttribute('data-url');
    } catch (error) {
      section.classList.remove('has-products-recently');
    } finally { delete el.dataset.loading; }
  });
}
document.addEventListener('DOMContentLoaded', () => btyRecentlyProduct());
document.addEventListener('shopify:section:load', event => btyRecentlyProduct(event.target));
